import Concept from "./Concept";
import Notes from "./Notes";
import Result from "./Result";
import Timeline from "./Timeline";

export default { Concept, Notes, Result, Timeline };
